export default __webpack_public_path__ + "static/media/Location_without_error.02625796.svg";